import React, { useState, useEffect, useContext } from 'react';
import * as net from "../../../lib/net";

import * as utils from "../../../assets/utils";
import Pms_Rvo from "../../rv/fb/rvo";
import Pms_Nota from "../nota/nota";
import Wnd_Confirm from "../../../lib/ui/wnd_confirm";

class Ns_Edit extends React.Component {
  constructor(props, context) {
    super(props);

    this.state = {};
    this.state.ynq = [];

    this.state.paa = [];
    this.state.aa = [];

    this.state.boknr = "";
    this.state.rvo = {};
    this.state.rvo.rblx0 = {};

    if(props.wnds) {
        this.state.boknr = props.wnds.boknr;
        this.state.blopnr = props.wnds.blopnr;
        this.state.rvo = props.wnds.rvo;

        if(!this.state.rvo) this.state.rvo = {};
        if(!this.state.rvo.resv00) this.state.rvo.resv00 = {};
        if(!this.state.rvo.resv01) this.state.rvo.resv01 = {};
        if(!this.state.rvo.rblx0) this.state.rvo.rblx0 = {};
        if(!this.state.rvo.charges) this.state.rvo.charges = {};
        if(!this.state.rvo.charges.bokat) this.state.rvo.charges.bokat = "";
        if(!this.state.rvo.charges.saldo) this.state.rvo.charges.saldo = "";
        if(!this.state.rvo.charges.paid) this.state.rvo.charges.paid = "";
        if(!this.state.rvo.charges.topay) this.state.rvo.charges.topay = "";
    }
      this.state.wnds = {};
      this.state.msg = {};
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      //this.rvo_br();
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }

    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = this.state.user;
      user[name] = value;
      this.setState({user: user});
      //setState({[name]: value});
    }
    wnd_close() {
		this.props.ctx.setState({ wnds: {} });
	};
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }
  fknSel(sel) {
    //alert(JSON.stringify(fkn));
      if(sel == "rvo") {
        var wnds = {};
        wnds.wnd_rvo = true;
        wnds.boknr = this.state.rvo.rblx0.r0boknr;
        wnds.rvo = this.state.rvo;
        this.setState({wnds: wnds});
      }
      if(sel == "rvc") {
          this.ns_rvc();
      }
      if(sel == "clear") {
          this.ns_del();
      }
      if(sel == "co") {
          this.ns_co();
      }
      if(sel == "nota") {
        //alert("Gäst måste skapas");
        if( !this.state.rvo.gsb00 || !this.state.rvo.gsb00.r0boknr) {
            alert(JSON.stringify(this.state.rvo.gsb00));
            return;
        }
        var wnds = {};
        wnds.wnd_nota = true;
        wnds.boknr = this.state.rvo.rblx0.r0boknr;
        wnds.rvo = this.state.rvo;
        this.setState({wnds: wnds});
      }
  }
    rvo_close(ctx) {
        ctx.setState({ wnd_rvo: false });
    };
    gst_close(ctx) {
        ctx.setState({ wnd_gst: false });
    };
  rvo_br() {
    var self = this;
    var prm = {};
    prm.req = "pms.op.rvo_br";
    prm.boknr = this.state.boknr;
    prm.blopnr = this.state.blopnr;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({rvo: ret.rco });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
    ns_del() {
        var self = this;
        var msg = { confirm: true, text: "OBS! Bokningen kommer fortfarande ta beläggning mm, fortsätta?", text0: "JA", text1: "NEJ", cb: "ns_del_do" };
        self.setState({ msg: msg });
    }
    ns_del_do(ret) {
        var self = this;
        if(ret != 0) {
            self.setState({ msg: {} });
            return;
        }
        self.setState({ msg: {} });
        var prm = {};
        prm.req = "pms.hot_fkn.ns_del";
        prm.boknr = this.state.rvo.rblx0.r0boknr;
        prm.lopnr = this.state.rvo.rblx0.r0lopnr;

        net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret.rca));

                //self.setState({rvo: ret.rco });
                self.props.ctx.setState({ wnds: {} });
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }
    ns_rvc(ret) {
        var self = this;

        var prm = {};
        prm.req = "pms.hot_fkn.ns_rvc";
        prm.rblx0 = this.state.rvo.rblx0;

        net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret.rca));

                //self.setState({rvo: ret.rco });
                self.props.ctx.setState({ wnds: {} });
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }
    ns_co() {
        var self = this;

        var prm = {};
        prm.req = "pms.gst_op.gst_force_checkout";
        prm.boknr = this.state.rvo.gsb00.r0boknr;
        prm.glopnr = this.state.rvo.gsb00.r0glopnr;
        prm.rumsnr = this.state.rvo.gsb00.r0rumsnr;
        prm.gsb00 = this.state.rvo.gsb00;
        //alert(JSON.stringify(prm));
        //return;

        net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret.ok));
                if(ret.ok) {
                    self.props.ctx.setState({ wnds: {} });
                    return;
                }
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }

  render() {
    //if(!this.props.show) return "";

    var title = this.props.title;
    if(!title) title = "";

	var html =
        <div className="mx_base">
        { this.props.backdrop ? <div className="mx_backdrop" /> : null }
        <div className="mx_dlg mx_70 flex-col" style={ this.dlg_style() }>
            <div className="mx_h01 flex-row" style={{background: "#1a456b", color: "#fff"}}>
            <div className="flex-col">
                <div>NO SHOW: { this.state.boknr }</div>
            </div>
            </div>
        <div className="mx_content flex">

            <div className="flex-row flex">
            <div className="flex-col flex">

            <div className="txt_box txt_bg_01 txt_22">
            <div className="flex-row">
                    <div className="flex-col flex">
                        <div className="txt_lbl">FÖRETAG:</div>
                        <div>{ this.state.rvo.resv00.Company }</div>
                    </div>
                    <div className="flex-col flex">
                        <div className="txt_lbl">TELE:</div>
                        <div>{ this.state.rvo.tele }</div>
                    </div>
            </div>
            <div className="flex-row">
                    <div className="flex-col flex">
                        <div className="txt_lbl">Namn:</div>
                        <div>{ this.state.rvo.resv01.Name }</div>
                    </div>
                    <div className="flex-col flex">
                        <div className="txt_lbl">EPOST:</div>
                        <div>{ this.state.rvo.resv01.Email }</div>
                    </div>
            </div>
            <div className="flex-row">
                    <div className="flex-col flex">
                        <div className="txt_lbl">ANM:</div>
                        <div>{ this.state.rvo.anm }</div>
                    </div>
            </div>
           </div>


             <div className="txt_box txt_bg_01 txt_22">
             <div className="flex-row">
                    <div className="flex-col flex">
                        <div className="txt_lbl">RUMSTYP:</div>
                        <div> { this.state.rvo.rblx0.r0typ }</div>
                    </div>
            </div>
             <div className="flex-row">
                    <div className="flex-col flex">
                        <div className="txt_lbl">PERIOD:</div>
                        <div>{ utils.toDate( this.state.rvo.rblx0.r0ankdatum ) } - { utils.toDate( this.state.rvo.rblx0.r0avrdatum ) }</div>
                    </div>
                    <div className="flex-col flex">
                        <div className="txt_lbl">GÄSTER:</div>
                        <div>{ this.state.rvo.rblx0.r0guests }</div>
                    </div>
            </div>

           </div>

           <div className="txt_box txt_bg_01 txt_22 flex">
           </div>

           </div>

             <div className="txt_box txt_bg_01 txt_22">
                    <div className="flex-row flex">
                        <div className="txt_lbl flex">BOKAT VÄRDE:</div>
                        <div className="txt_price">{ utils.toPris( this.state.rvo.charges.bokat ) }</div>
                    </div>
                    <div className="flex-row flex">
                        <div className="txt_lbl flex">SALDO:</div>
                        <div className="txt_price">{ utils.toPris( this.state.rvo.charges.saldo ) }</div>
                    </div>
                    <div className="flex-row flex">
                        <div className="txt_lbl flex">BETALT:</div>
                        <div className="txt_price">{ utils.toPris( this.state.rvo.charges.paid ) }</div>
                    </div>
                    <div className="flex-row flex">
                        <div className="txt_lbl flex">ATT BETALA:</div>
                        <div className="txt_price">{ utils.toPris( this.state.rvo.charges.topay ) }</div>
                    </div>
                    <div className="divider_blue"></div>
                    <div className="flex-row flex py-2">
                        <div className="txt_lbl flex">GÄSTER:</div>
                        <div className="txt_price">{ this.state.rvo.nrg }</div>
                    </div>
            </div>

            </div>
            <div className="divider_orange"></div>
        <div className="web-row">
        <div className="web-col flex">
            <div className="wnd-btn" onClick={() => this.fknSel("clear") } >
                <div>RENSA NOSHOW</div>
                <div></div>
            </div>
            <div className="wnd-btn" onClick={() => this.wnd_close() } >
                <div>STÄNG</div>
                <div></div>
            </div>
        </div>
            <div className="web-col flex" style={{padding: "0px 10px"}}>
                <div className="wnd-btn" onClick={() => this.fknSel("rvc") } >
                    <div>AVBOKA DELBOKNING</div>
                    <div></div>
                </div>
                { this.state.rvo.gsb00.r0boknr ?
                <div className="wnd-btn" onClick={() => this.fknSel("co") } >
                    <div>CHECKA UT GÄST</div>
                    <div></div>
                </div>
                : null }
            </div>
         <div className="web-col flex" style={{padding: "0px 10px"}}>
            <div className="wnd-btn" onClick={() => this.fknSel("rvo") } >
                <div>ÖPPNA BOKNING</div>
                <div></div>
            </div>
            <div className="wnd-btn" onClick={() => this.fknSel("nota") } >
                <div>ÖPPNA NOTA</div>
                <div></div>
            </div>
       </div>
       </div>

        </div>
      </div>
        { this.state.wnds.wnd_rvo ? <Pms_Rvo wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
        { this.state.wnds.wnd_nota ? <Pms_Nota wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
        { this.state.msg.confirm ? <Wnd_Confirm msg={this.state.msg} ctx={this} /> : null }
    </div>
	;
	return html;
  };
}

export default Ns_Edit;